import axios from 'axios';

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

const http = axios.create({ baseURL: API });

http.interceptors.request.use((cfg) => {
  const tok = localStorage.getItem('cv_token');
  if (tok) cfg.headers.Authorization = `Bearer ${tok}`;
  return cfg;
});

export const api = {
  // auth
  register: (data) => http.post('/auth/register', data).then((r) => r.data),
  login: (data) => http.post('/auth/login', data).then((r) => r.data),
  me: () => http.get('/auth/me').then((r) => r.data),
  // livret
  getLivret: () => http.get('/livret').then((r) => r.data),
  upsertLivret: (data) => http.post('/livret', data).then((r) => r.data),
  // articles
  listArticles: (params = {}) => http.get('/articles', { params }).then((r) => r.data),
  getArticle: (slug) => http.get(`/articles/${slug}`).then((r) => r.data),
  // admin
  adminListArticles: () => http.get('/admin/articles').then((r) => r.data),
  adminCreateArticle: (data) => http.post('/admin/articles', data).then((r) => r.data),
  adminUpdateArticle: (id, data) => http.put(`/admin/articles/${id}`, data).then((r) => r.data),
  adminDeleteArticle: (id) => http.delete(`/admin/articles/${id}`).then((r) => r.data),
  adminArchiveArticle: (id) => http.post(`/admin/articles/${id}/archive`).then((r) => r.data),
  adminUnarchiveArticle: (id) => http.post(`/admin/articles/${id}/unarchive`).then((r) => r.data),
  adminToggleCoverLock: (id) => http.patch(`/admin/articles/${id}/cover-lock`).then((r) => r.data),
  adminStats: () => http.get('/admin/stats').then((r) => r.data),
  adminActivity: (limit = 30) => http.get('/admin/activity', { params: { limit } }).then((r) => r.data),
  adminListUsers: (params = {}) => http.get('/admin/users', { params }).then((r) => r.data),
  adminUpdateUser: (id, data) => http.patch(`/admin/users/${id}`, data).then((r) => r.data),
  adminApproveUser: (id) => http.post(`/admin/users/${id}/approve`).then((r) => r.data),
  adminDisableUser: (id) => http.post(`/admin/users/${id}/disable`).then((r) => r.data),
  adminEnableUser: (id) => http.post(`/admin/users/${id}/enable`).then((r) => r.data),
  adminDeleteUser: (id) => http.delete(`/admin/users/${id}`).then((r) => r.data),
  adminResetPassword: (id) => http.post(`/admin/users/${id}/reset-password`).then((r) => r.data),
  adminSyncArticles: () => http.post('/admin/sync-articles').then((r) => r.data),
  adminGlobalLivret: () => http.get('/admin/livret').then((r) => r.data),
  // teacher / link
  linkTeacher: (teacher_code) => http.post('/eleve/link-teacher', { teacher_code }).then((r) => r.data),
  unlinkTeacher: () => http.post('/eleve/unlink-teacher').then((r) => r.data),
  teacherStudents: () => http.get('/teacher/students').then((r) => r.data),
  teacherStudentDetail: (id) => http.get(`/teacher/student/${id}`).then((r) => r.data),
  teacherUnlinkStudent: (id) => http.delete(`/teacher/student/${id}/unlink`).then((r) => r.data),

  // Flash séance (partage QR sans inscription)
  flashSeanceCreate: (payload) => http.post('/teacher/flash-seance', payload).then((r) => r.data),
  flashSeanceList: () => http.get('/teacher/flash-seance').then((r) => r.data),
  flashSeanceDelete: (id) => http.delete(`/teacher/flash-seance/${id}`).then((r) => r.data),
  flashSeancePublic: (token) => http.get(`/public/flash-seance/${token}`).then((r) => r.data),
  flashSeanceQcm: (token) => http.get(`/public/flash-seance/${token}/qcm`).then((r) => r.data),
  flashSeanceClaim: (token) => http.post(`/flash-seance/${token}/claim`).then((r) => r.data),
  flashSeanceQcmResult: (token, score, total) => http.post(`/flash-seance/${token}/qcm-result`, { score, total }).then((r) => r.data),
  flashSelfEval: (token, evals) => http.post(`/public/flash-seance/${token}/self-eval`, { evals }).then((r) => r.data),
  motoCatalog: () => http.get('/moto/catalog').then((r) => r.data),
  motoEnquete: (slug) => http.get(`/moto/enquete/${slug}`).then((r) => r.data),
  motoDossier: (slug) => http.get(`/moto/dossier/${slug}`).then((r) => r.data),
  motoSatellite: (parent, slug) => http.get(`/moto/satellite/${parent}/${slug}`).then((r) => r.data),
  motoPlateau: () => http.get('/moto/plateau').then((r) => r.data),
  motoLivret: () => http.get('/moto/livret').then((r) => r.data),
  motoFichesPlateau: () => http.get('/moto/fiches-plateau').then((r) => r.data),
  studentStepStatus: () => http.get('/student/step-status').then((r) => r.data),
  studentSeanceHistory: () => http.get('/student/seance-history').then((r) => r.data),
  studentQcmBadges: () => http.get('/student/qcm-badges').then((r) => r.data),
  studentPingActivity: () => http.post('/student/ping-activity').then((r) => r.data),
  studentStreak: () => http.get('/student/streak').then((r) => r.data),
  // Phase 1-2-3 : suivi élève↔enseignant
  studentDashboard: () => http.get('/student/dashboard').then((r) => r.data),
  studentNextPrep: () => http.get('/student/next-prep').then((r) => r.data),
  linkTeacher: (teacher_code) => http.post('/eleve/link-teacher', { teacher_code }).then((r) => r.data),
  unlinkTeacher: () => http.post('/eleve/unlink-teacher').then((r) => r.data),
  teacherValidateLivret: (studentId, data) => http.post(`/teacher/livret/${studentId}/validate`, data).then((r) => r.data),
  seanceTemplates: () => http.get('/seances/templates').then((r) => r.data),
  seanceTemplate: (id) => http.get(`/seances/templates/${id}`).then((r) => r.data),
  createSeance: (data) => http.post('/teacher/seances', data).then((r) => r.data),
  teacherSeances: (params = {}) => http.get('/teacher/seances', { params }).then((r) => r.data),
  getSeance: (id) => http.get(`/seances/${id}`).then((r) => r.data),
  updateSeance: (id, data) => http.patch(`/teacher/seances/${id}`, data).then((r) => r.data),
  seancePdfUrl: (id) => `${API}/teacher/seances/${id}/pdf`,
  // newsletter
  newsletterSubscribe: (data) => http.post('/newsletter/subscribe', data).then((r) => r.data),
  // password reset
  requestPasswordReset: (email) => http.post('/auth/request-password-reset', { email }).then((r) => r.data),
  verifyResetToken: (token) => http.get(`/auth/reset-password/${token}`).then((r) => r.data),
  resetPassword: (data) => http.post('/auth/reset-password', data).then((r) => r.data),
  // session sheets (fiches de séance partageables)
  createSessionSheet: (data) => http.post('/teacher/session-sheets', data).then((r) => r.data),
  listSessionSheets: () => http.get('/teacher/session-sheets').then((r) => r.data),
  publicSessionSheet: (token) => http.get(`/session-sheets/${token}`).then((r) => r.data),
  publicSheetProgression: (token) => http.get(`/session-sheets/${token}/progression`).then((r) => r.data),
  deleteSessionSheet: (id) => http.delete(`/teacher/session-sheets/${id}`).then((r) => r.data),
  // mock exams (examens blancs partageables via QR code)
  createMockExam: (data) => http.post('/teacher/mock-exams', data).then((r) => r.data),
  listMockExams: () => http.get('/teacher/mock-exams').then((r) => r.data),
  publicMockExam: (token) => http.get(`/mock-exams/${token}`).then((r) => r.data),
  deleteMockExam: (id) => http.delete(`/teacher/mock-exams/${id}`).then((r) => r.data),
  // bilans de reprise (retour AAC / conduite supervisée)
  createBilanReprise: (data) => http.post('/teacher/bilans-reprise', data).then((r) => r.data),
  createBilanLive: (data) => http.post('/teacher/bilans-reprise/live', data).then((r) => r.data),
  updateBilanLive: (id, data) => http.put(`/teacher/bilans-reprise/${id}/live`, data).then((r) => r.data),
  finalizeBilanLive: (id) => http.post(`/teacher/bilans-reprise/${id}/finalize`).then((r) => r.data),
  listBilansReprise: () => http.get('/teacher/bilans-reprise').then((r) => r.data),
  publicBilanReprise: (token) => http.get(`/bilans-reprise/${token}`).then((r) => r.data),
  deleteBilanReprise: (id) => http.delete(`/teacher/bilans-reprise/${id}`).then((r) => r.data),

  // Actu de la vie & du fun
  actuFeedPublic: (limit = 20) => http.get('/actu/feed', { params: { limit } }).then((r) => r.data),
  actuFeedStudent: (limit = 25) => http.get('/actu/feed/student', { params: { limit } }).then((r) => r.data),
  teacherActuList: () => http.get('/teacher/actu').then((r) => r.data),
  teacherActuCreate: (data) => http.post('/teacher/actu', data).then((r) => r.data),
  teacherActuPin: (id, student_ids) => http.patch(`/teacher/actu/${id}/pin`, { student_ids }).then((r) => r.data),
  teacherActuDelete: (id) => http.delete(`/teacher/actu/${id}`).then((r) => r.data),
  teacherStudentsLite: () => http.get('/teacher/students-lite').then((r) => r.data),
  adminActuList: () => http.get('/admin/actu').then((r) => r.data),
  adminActuCreate: (data) => http.post('/admin/actu', data).then((r) => r.data),
  adminActuUpdate: (id, data) => http.patch(`/admin/actu/${id}`, data).then((r) => r.data),
  adminActuDelete: (id) => http.delete(`/admin/actu/${id}`).then((r) => r.data),
  adminActuGenerate: () => http.post('/admin/actu/generate').then((r) => r.data),

  // Demandes d'informations (auto-écoles, moniteurs indépendants)
  submitDemoRequest: (data) => http.post('/demo-request', data).then((r) => r.data),
  adminDemoRequestList: (status_filter) => http.get('/admin/demo-requests', { params: status_filter ? { status_filter } : {} }).then((r) => r.data),
  adminDemoRequestUpdate: (id, data) => http.patch(`/admin/demo-requests/${id}`, data).then((r) => r.data),
  adminDemoRequestReply: (id, data) => http.post(`/admin/demo-requests/${id}/reply`, data).then((r) => r.data),
  adminPageStats: (days = 30) => http.get('/admin/page-stats', { params: { days } }).then((r) => r.data),
  trackPageView: (path) => http.post('/track', { path }).catch(() => {}),
  adminDemoRequestDelete: (id) => http.delete(`/admin/demo-requests/${id}`).then((r) => r.data),

  // Boîte mail admin (Resend Inbound — contact@codevoiture.fr)
  adminInboxList: (folder) => http.get('/admin/inbox', { params: folder ? { folder } : {} }).then((r) => r.data),
  adminInboxUpdate: (id, data) => http.patch(`/admin/inbox/${id}`, data).then((r) => r.data),
  adminInboxReply: (id, data) => http.post(`/admin/inbox/${id}/reply`, data).then((r) => r.data),
  adminInboxDelete: (id) => http.delete(`/admin/inbox/${id}`).then((r) => r.data),
  adminInboxAttachment: (mailId, attId) => http.get(`/admin/inbox/${mailId}/attachments/${attId}`, { responseType: 'blob' }).then((r) => r.data),

  // Messagerie interne enseignant ↔ élèves
  messagesThreads: () => http.get('/messages/threads').then((r) => r.data),
  messagesWith: (otherId) => http.get(`/messages/with/${otherId}`).then((r) => r.data),
  messagesSend: (otherId, data) => http.post(`/messages/with/${otherId}`, data).then((r) => r.data),

  // Secrétariat — gestion auto-école
  secFormules: () => http.get('/secretariat/formules').then((r) => r.data),
  secStats: () => http.get('/secretariat/stats').then((r) => r.data),
  secSyncData: () => http.post('/secretariat/sync-data').then((r) => r.data),
  secBackup: () => http.get('/secretariat/backup', { responseType: 'blob' }),
  secBackupEmail: () => http.post('/secretariat/backup-email').then((r) => r.data),
  secEleves: () => http.get('/secretariat/eleves').then((r) => r.data),
  secCreateEleve: (d) => http.post('/secretariat/eleves', d).then((r) => r.data),
  secUpdateEleve: (id, d) => http.patch(`/secretariat/eleves/${id}`, d).then((r) => r.data),
  secDeleteEleve: (id) => http.delete(`/secretariat/eleves/${id}`).then((r) => r.data),
  secTeachers: () => http.get('/secretariat/enseignants').then((r) => r.data),
  secCreateTeacher: (d) => http.post('/secretariat/enseignants', d).then((r) => r.data),
  secUpdateTeacher: (id, d) => http.patch(`/secretariat/enseignants/${id}`, d).then((r) => r.data),
  secDeleteTeacher: (id) => http.delete(`/secretariat/enseignants/${id}`).then((r) => r.data),
  secLessons: (start, end, teacherId) => http.get('/secretariat/lessons', { params: { start, end, ...(teacherId ? { teacher_id: teacherId } : {}) } }).then((r) => r.data),
  secCreateLesson: (d) => http.post('/secretariat/lessons', d).then((r) => r.data),
  secUpdateLesson: (id, d) => http.patch(`/secretariat/lessons/${id}`, d).then((r) => r.data),
  secDeleteLesson: (id) => http.delete(`/secretariat/lessons/${id}`).then((r) => r.data),
  secSettings: () => http.get('/secretariat/settings').then((r) => r.data),
  secUpdateSettings: (d) => http.patch('/secretariat/settings', d).then((r) => r.data),
  secExportDsr: (start, end, mode) => http.get('/secretariat/export-dsr', { params: { start, end, mode }, responseType: 'blob' }).then((r) => r.data),
  secImportPlanning: (file, teacherFileId, dryRun) => {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('teacher_file_id', teacherFileId);
    fd.append('dry_run', dryRun ? 'true' : 'false');
    return http.post('/secretariat/import-planning', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
  },
  secImportEleves: (file, teacherFileId, dryRun) => {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('teacher_file_id', teacherFileId || '');
    fd.append('dry_run', dryRun ? 'true' : 'false');
    return http.post('/secretariat/import-eleves', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
  },
  teacherStudentBilans: (id) => http.get(`/teacher/student/${id}/bilans`).then((r) => r.data),
  teacherCreateStudentBilan: (id, d) => http.post(`/teacher/student/${id}/bilans`, d).then((r) => r.data),
  teacherDeleteStudentBilan: (bid) => http.delete(`/teacher/student-bilans/${bid}`).then((r) => r.data),
  myBilans: () => http.get('/eleve/bilans').then((r) => r.data),
  teacherFinalizeLivret: (id) => http.post(`/teacher/livret/${id}/finalize`).then((r) => r.data),
  myLivretValidation: () => http.get('/eleve/livret-validation').then((r) => r.data),
  myFormation: () => http.get('/eleve/formation').then((r) => r.data),
  completeMyLesson: (id) => http.post(`/my-planning/${id}/complete`).then((r) => r.data),
  fixLessonStudent: (id, payload) => http.post(`/my-planning/${id}/fix-student`, payload).then((r) => r.data),
  addMyLesson: (payload) => http.post('/my-planning/add', payload).then((r) => r.data),
  rescheduleMyLesson: (id, payload) => http.post(`/my-planning/${id}/reschedule`, payload).then((r) => r.data),
  cancelMyLesson: (id, status) => http.post(`/my-planning/${id}/cancel`, { status }).then((r) => r.data),
  myPlanning: () => http.get('/my-planning').then((r) => r.data),
  adminCreateSecretaire: (d) => http.post('/admin/create-secretaire', d).then((r) => r.data),

  // RVP Cast — télécommande cross-device
  castCreate: (slug) => http.post('/rvp-cast/session', { slug }).then((r) => r.data),
  castGet: (code) => http.get(`/rvp-cast/${code}`).then((r) => r.data),
  castUpdate: (code, state) => http.put(`/rvp-cast/${code}`, state).then((r) => r.data),
  castClose: (code) => http.delete(`/rvp-cast/${code}`).then((r) => r.data),
  castJoin: (code, data) => http.post(`/rvp-cast/${code}/join`, data).then((r) => r.data),
};

export default http;
